import { useQuery } from '@tanstack/react-query';

import { api, unwrap, type StaffProfile } from '@/api/client';
import type { components } from '@/api/schema';

import { useAuth } from './AuthProvider';

export type Seccion = components['schemas']['StaffSection']['section'];
export type Nivel = 'ver' | 'editar';

/** Perfil con secciones. Arranca con lo que trajo el login/refresh y se revalida en segundo plano. */
export function useMe() {
  const { status, staff } = useAuth();
  return useQuery({
    queryKey: ['me'],
    queryFn: () => unwrap<StaffProfile>(api.GET('/api/v1/admin/me')),
    enabled: status === 'authenticated',
    initialData: staff ?? undefined,
    staleTime: 60_000,
  });
}

/** ¿Puede el staff entrar a la sección con ese nivel? La API valida lo mismo en cada ruta. */
export function puede(perfil: StaffProfile | undefined, seccion: Seccion, nivel: Nivel = 'ver') {
  if (!perfil) return false;
  if (perfil.isSuperadmin) return true;
  const actual = perfil.sections.find((s) => s.section === seccion)?.level ?? null;
  return actual === 'editar' || (actual === 'ver' && nivel === 'ver');
}

export function useCan(seccion: Seccion | undefined, nivel: Nivel = 'ver'): boolean {
  const { data } = useMe();
  if (!seccion) return true;
  return puede(data, seccion, nivel);
}
